import React from 'react';
import logo from './logo.svg';
import './App.css';
import { browserName, deviceDetect, fullBrowserVersion, isAndroid, isChrome, isConsole, isMobile, isSmartTV, isTablet, isWindows, osName, osVersion } from 'react-device-detect';

function App() {
  return (
    <div>
      <div>&nbsp;&nbsp;isMobile: {isMobile.toString()}</div>
      <div>&nbsp;&nbsp;isAndroid: {isAndroid.toString()}</div>
      <div>&nbsp;&nbsp;isSmartTV: {isSmartTV.toString()}</div>
      <div>&nbsp;&nbsp;isChrome: {isChrome.toString()}</div>
      <div>&nbsp;&nbsp;isTablet: {isTablet.toString()}</div>
      <div>&nbsp;&nbsp;browserName: {browserName.toString()}</div>
      <div>&nbsp;&nbsp;fullBrowserVersion: {fullBrowserVersion.toString()}</div>
      <div>&nbsp;&nbsp;osName: {osName.toString()}</div>
      <div>&nbsp;&nbsp;osVersion: {osVersion.toString()}</div>
      <div>&nbsp;&nbsp;isConsole: {isConsole.toString()}</div>
      <div>&nbsp;&nbsp;isWindows: {isWindows.toString()}</div>
    </div>
  );
}

export default App;
